/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.BillingFrequency_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.BillingFrequency domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum BillingFrequency_ {
   /// <summary>
   ///   One Time (not recurring) (once)
   /// </summary>
   OneTime = 0,
   /// <summary>
   ///   Monthly (month)
   /// </summary>
   Monthly = 1,
   /// <summary>
   ///   Quarterly (3 months)
   /// </summary>
   Quarterly = 2,
   /// <summary>
   ///   Annually (year)
   /// </summary>
   Annually = 4,
   /// <summary>
   ///   Scheduled (definite dates) (sched)
   /// </summary>
   Scheduled = 5,
   /// <summary>
   ///   Semi-Annually (6 months)
   /// </summary>
   SemiAnnually = 7,
   /// <summary>
   ///   Monthly (annual contract) (month*)
   /// </summary>
   MonthlyAnnualContract = 8,
   /// <summary>
   ///   Annually (contract) (year*)
   /// </summary>
   AnnualContract = 9,
   /// <summary>
   ///   Partner Billed (invoice)
   /// </summary>
   PartnerBilled = 99
}

export const BillingFrequencies: BillingFrequency[] = [
   {
      code: BillingFrequency_.OneTime,
      literal: 'OneTime',
      description: 'One Time (not recurring)',
      shortDescription: 'once',
      listPriority: 0,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.Monthly,
      literal: 'Monthly',
      description: 'Monthly',
      shortDescription: 'month',
      listPriority: 1,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.Quarterly,
      literal: 'Quarterly',
      description: 'Quarterly',
      shortDescription: '3 months',
      listPriority: 2,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.Annually,
      literal: 'Annually',
      description: 'Annually',
      shortDescription: 'year',
      listPriority: 4,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.Scheduled,
      literal: 'Scheduled',
      description: 'Scheduled (definite dates)',
      shortDescription: 'sched',
      listPriority: 0,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.SemiAnnually,
      literal: 'SemiAnnually',
      description: 'Semi-Annually',
      shortDescription: '6 months',
      listPriority: 3,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.MonthlyAnnualContract,
      literal: 'MonthlyAnnualContract',
      description: 'Monthly (annual contract)',
      shortDescription: 'month*',
      listPriority: 5,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.AnnualContract,
      literal: 'AnnualContract',
      description: 'Annually (contract)',
      shortDescription: 'year*',
      listPriority: 7,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.PartnerBilled,
      literal: 'PartnerBilled',
      description: 'Partner Billed',
      shortDescription: 'invoice',
      listPriority: 0,

      typeName: "BillingFrequency"
   }
]

export class BillingFrequency implements IDomainModel {
   code: BillingFrequency_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: BillingFrequency_): BillingFrequency {
      return BillingFrequencies.find(d => d.code === code)
   }
}
